import get from 'lodash/get';
import { SOCIAL_LIST } from '../../helper/urls/constants';

/**
 * Function for get shared link by type
 * @param {string} type
 * @return {string}
 */
export default (type) => get(SOCIAL_LIST, [type, 'getShareUrl'], () => null);
